export default __webpack_public_path__ + "static/media/spatial-repetition-stage-3-unread.73576a23.png";